var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBenchWarmer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 81 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-11621,-529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10440,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bench-Warmer",
    transform: "matrix(1,-0,-0,1,1181.05,529)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0.015,
    y: 9.163,
    width: "81px",
    height: "62px"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "81px",
    height: "62px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAAA+CAYAAABTLfe5AAAACXBIWXMAAA7EAAAOxAGVKw4bAAACqElEQVR4nO2cPWsUURSGn5Oshf4AxcbGQgSLYApttAoI2vsH/AOWVjYiIlhZCAqKCLbBBZtoIQRUVEi6iAREETGNHyBCyCY5FrtCmL3ZmZ197+4Ez1Oe2fty5mHmMOx8GDVwdwMuAYd21s3sep28cePuc8CpQvmRmX0ZZxPT7r7kBcbWwIi4+61i7+5+pm7elLK5/5WQKKCVKvZm3iCS2yusazJWpX8z6xtbfRJ7s+FKWRZwNFF/WtZEQzieqN0EfpSsawP3isXUkXgYOD98XzDCuiZwusJvVlPFmIkCQqKAkCggJAoIiQJCooCQKCAkCgiJAkKigJAoICQKCIkCQqKAkCggJAoIiQJCooCQKCAkCgiJAlJ3+74Db0rWGXACOFCol61rCkfo3tXcyQrwu2Td51Sx72a1u08D+0rCpoCXwEyhvr9kXVO4AVwu1Obo7tMgNs1ss1jsOxLNbAvYGpTUE933JICZrZc00QjcPbV/G3X7j5koICQKaLl7cTZUYQo4WCzWzJoEJxO1i+4+WyOrbXvp4cyGciFOZwEhUUBIFBASBYREASFRQEgU0AI+TLqJPc6fSTcQBEHQJCq9Rubu54BjQ2Z/BeZTr3GNG3efAc4Ou87MbiubeJx4tbWMu7IGRsTdZ929M+wOVM3PeZ04nzF7WD4B2V4IzyXxG/AiU3YdfgLLucJzSXxgZhuZsofGzLaB+7nyc0hcB55kyB2V52Q6pXNIXAM+ZsgdCTPrkGlO55C4SHcGNZEFSu6p10Et0YE7Tbg23IVluuNGilrie+CtOFOGma3RnY1S1BLbDT4K/3EN2FYGqiU26dowiZktscu3HOqilNgB3gnzcrKoDFNKfGhmv4R5OXmmDEt+XCjBKvB6wHYHro7ezthYAF5R8V+sMv4CAqAX/wJZZuoAAAAASUVORK5CYII="
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBenchWarmer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Bench_Warmer.e0caa0e50034bd73a5798274a84accf2.svg";